import { track } from '@ramp106/omrjs-tracking-reviews'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useArchiveReviewsLeadMutation, useUnarchiveReviewsLeadMutation } from '@/gql/reviews'
import { showNotification } from '@/helpers/notificationHelper'

// reviewsLeads is refetched for the case the list is still mounted; the list
// provider additionally runs cache-and-network so a later mount re-filters too
const mutationOptions = {
  clientId: 'reviews',
  refetchQueries: ['reviewsLead', 'reviewsLeads'],
  awaitRefetchQueries: true,
}

export function useLeadArchive() {
  const { t } = useI18n()
  const { mutate: archiveMutate, loading: archiving } = useArchiveReviewsLeadMutation(mutationOptions)
  const { mutate: unarchiveMutate, loading: unarchiving } = useUnarchiveReviewsLeadMutation(mutationOptions)

  async function toggleArchive(leadId: string, archived: boolean, ctaPosition: string): Promise<void> {
    track('cta_click', {
      surface: 'cta',
      category: 'engagement',
      cta_id: archived ? 'lead_unarchive' : 'lead_archive',
      cta_position: ctaPosition,
    })

    try {
      if (archived) {
        await unarchiveMutate({ id: leadId })
        showNotification(t('Leads.archive.unarchivedNotification'), 'success')
      } else {
        await archiveMutate({ id: leadId })
        showNotification(t('Leads.archive.archivedNotification'), 'success')
      }
    } catch {
      showNotification(t('Leads.archive.errorNotification'), 'error', 10000)
    }
  }

  const loading = computed(() => archiving.value || unarchiving.value)

  return { toggleArchive, loading }
}
